// ═════════════════════════════════════════════════════════════════════════════
// RomeoReportDashboard.js — Advanced Analytics View
// ✅ Standalone — does NOT modify existing Romeo Add Entry or other dashboards
// ✅ Add route in App.jsx: <Route path="/ppc/romeo-report" element={<RomeoReportDashboard />} />
// ═════════════════════════════════════════════════════════════════════════════
//
// ── PHP BACKEND: Add this case block inside romeo.php switch($action) ────────
//
// case 'analytics': {
//   $from = $_GET['from'] ?? date('Y-m-01');
//   $to   = $_GET['to']   ?? date('Y-m-d');
//   $line       = $_GET['line']       ?? '';
//   $contractor = $_GET['contractor'] ?? '';
//   $shift      = $_GET['shift']      ?? '';
//   $w = "WHERE re.entry_date BETWEEN ? AND ?"; $p = [$from,$to];
//   if($line)       { $w .= " AND re.line=?";       $p[]=$line; }
//   if($contractor) { $w .= " AND re.contractor=?"; $p[]=$contractor; }
//   if($shift)      { $w .= " AND re.shift=?";      $p[]=$shift; }
//
//   $stmt=$pdo->prepare("SELECT COUNT(DISTINCT re.contractor) tc,
//     SUM(re.male_associates+COALESCE(re.supporting_male,0)) ta,
//     SUM(re.total_no_trays) tt, SUM(re.total_no_vehicles) tv,
//     SUM(re.total_quantity) tq,
//     AVG(CASE WHEN re.shift_hours>0 THEN re.total_no_trays/re.shift_hours END) ath,
//     AVG(re.kg_per_tray) akt, COUNT(*) entries
//     FROM romeo_entries re $w");
//   $stmt->execute($p); $kpi=$stmt->fetch(PDO::FETCH_ASSOC);
//
//   $stmt=$pdo->prepare("SELECT re.entry_date date,
//     COALESCE(SUM(rq.hon_qty),0) hon_qty, COALESCE(SUM(rq.hon_count),0) hon_count,
//     AVG(CASE WHEN re.shift_hours>0 THEN re.total_no_trays/re.shift_hours END) trays_per_hour,
//     AVG(re.kg_per_tray) avg_kg_tray, SUM(re.total_quantity) total_qty
//     FROM romeo_entries re
//     LEFT JOIN romeo_quantity_rows rq ON rq.entry_id=re.id
//     $w GROUP BY re.entry_date ORDER BY re.entry_date");
//   $stmt->execute($p); $trend=$stmt->fetchAll(PDO::FETCH_ASSOC);
//
//   $stmt=$pdo->prepare("SELECT re.contractor,
//     SUM(re.total_no_trays) total_trays, SUM(re.total_quantity) total_qty,
//     COALESCE(SUM(rq.hon_qty),0) total_hon_qty,
//     COALESCE(SUM(rq.hon_count),0) total_hon_count,
//     AVG(CASE WHEN re.shift_hours>0 THEN re.total_no_trays/re.shift_hours END) productivity
//     FROM romeo_entries re
//     LEFT JOIN romeo_quantity_rows rq ON rq.entry_id=re.id
//     $w GROUP BY re.contractor ORDER BY total_hon_qty DESC");
//   $stmt->execute($p); $cpf=$stmt->fetchAll(PDO::FETCH_ASSOC);
//
//   $stmt=$pdo->prepare("SELECT re.line,
//     SUM(re.total_quantity) quantity, SUM(re.total_no_trays) trays,
//     COALESCE(SUM(rq.hon_qty),0) hon_qty,
//     AVG(CASE WHEN re.shift_hours>0 THEN re.total_no_trays/re.shift_hours END) productivity
//     FROM romeo_entries re
//     LEFT JOIN romeo_quantity_rows rq ON rq.entry_id=re.id
//     $w GROUP BY re.line");
//   $stmt->execute($p); $lines=$stmt->fetchAll(PDO::FETCH_ASSOC);
//
//   $stmt=$pdo->prepare("SELECT rq.lot_number,
//     SUM(rq.hon_count) hon_count, SUM(rq.hon_qty) hon_qty, SUM(rq.hours) hours,
//     ROUND(SUM(rq.hon_qty)/NULLIF(SUM(rq.hours),0),2) productivity
//     FROM romeo_quantity_rows rq
//     JOIN romeo_entries re ON rq.entry_id=re.id
//     $w GROUP BY rq.lot_number ORDER BY hon_qty DESC LIMIT 50");
//   $stmt->execute($p); $lots=$stmt->fetchAll(PDO::FETCH_ASSOC);
//
//   $clist=$pdo->query("SELECT DISTINCT contractor FROM romeo_entries ORDER BY contractor")->fetchAll(PDO::FETCH_COLUMN);
//   echo json_encode(['success'=>true,'kpi'=>$kpi,'dailyTrend'=>$trend,
//     'contractorPerf'=>$cpf,'lineComparison'=>$lines,'lotAnalysis'=>$lots,'contractors'=>$clist]);
//   break;
// }
// ── END PHP BACKEND ───────────────────────────────────────────────────────────

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { usePPCAuth, PPC_API_URL } from './PPCContext';

// ─────────────────────────────────────────────────────────────────────────────
// CSS
// ─────────────────────────────────────────────────────────────────────────────
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
:root{--red:#d32f2f;--blue:#1565c0;--blue-dk:#0d47a1;--grad:linear-gradient(135deg,#d32f2f 0%,#1565c0 100%);--green:#059669;--amber:#d97706;--purple:#7b1fa2;--bg:#f0f2f5;--surface:#fff;--border:#e2e6ea;--text:#1a1d23;--muted:#6b7280;}
.rrd-wrap{min-height:100vh;background:var(--bg);font-family:'DM Sans',sans-serif;color:var(--text);font-size:13px}
.rrd-hdr{background:var(--grad);padding:11px 20px;display:flex;justify-content:space-between;align-items:center;position:sticky;top:0;z-index:50;box-shadow:0 2px 14px rgba(211,47,47,.28);flex-wrap:wrap;gap:8px}
.rrd-hdr-left{display:flex;align-items:center;gap:10px}
.rrd-hdr-right{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.rrd-back-btn{background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.28);color:#fff;padding:6px 12px;border-radius:6px;cursor:pointer;font-size:12px;font-family:inherit;font-weight:500}
.rrd-back-btn:hover{background:rgba(255,255,255,.28)}
.rrd-title{color:#fff;font-size:15px;font-weight:600;letter-spacing:.4px}
.rrd-subtitle{color:rgba(255,255,255,.7);font-size:11px}
.rrd-badge{background:rgba(255,255,255,.2);color:#fff;font-size:10px;padding:3px 9px;border-radius:20px;font-weight:500}
.rrd-export-btn{background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.28);color:#fff;padding:6px 13px;border-radius:6px;cursor:pointer;font-size:12px;font-family:inherit;font-weight:600}
.rrd-export-btn:hover{background:rgba(255,255,255,.28)}
.rrd-main{padding:16px 20px;display:grid;gap:14px}
.rrd-filter-bar{background:var(--surface);border:1px solid var(--border);border-radius:10px;padding:12px 16px;display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap}
.rrd-ff{display:flex;flex-direction:column;gap:4px;min-width:130px}
.rrd-ff label{font-size:10px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.4px}
.rrd-ff input,.rrd-ff select{padding:7px 10px;border:1.5px solid var(--border);border-radius:7px;font-family:inherit;font-size:12px;background:var(--surface);color:var(--text);outline:none}
.rrd-ff input:focus,.rrd-ff select:focus{border-color:var(--blue)}
.rrd-apply-btn{padding:8px 18px;border-radius:7px;border:none;background:var(--grad);color:#fff;font-family:inherit;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap}
.rrd-reset-btn{padding:8px 14px;border-radius:7px;border:1.5px solid var(--border);background:var(--surface);color:var(--muted);font-family:inherit;font-size:12px;font-weight:600;cursor:pointer}
.rrd-kpi-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:10px}
.rrd-kpi{background:var(--surface);border:1px solid var(--border);border-radius:10px;padding:12px 14px;border-left:4px solid var(--blue);display:flex;align-items:center;gap:10px}
.rrd-kpi.green{border-left-color:var(--green)}.rrd-kpi.amber{border-left-color:var(--amber)}.rrd-kpi.purple{border-left-color:var(--purple)}.rrd-kpi.red{border-left-color:var(--red)}
.rrd-kpi-icon{font-size:20px;flex-shrink:0}
.rrd-kpi-label{font-size:10px;color:var(--muted);margin-bottom:3px;font-weight:500}
.rrd-kpi-val{font-size:15px;font-weight:700;font-family:'DM Mono',monospace}
.rrd-kpi-val.green{color:var(--green)}.rrd-kpi-val.amber{color:var(--amber)}.rrd-kpi-val.purple{color:var(--purple)}.rrd-kpi-val.blue{color:var(--blue)}.rrd-kpi-val.red{color:var(--red)}
.rrd-card{background:var(--surface);border:1px solid var(--border);border-radius:12px;overflow:hidden}
.rrd-card-hdr{padding:11px 16px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--border);background:#fafbfc}
.rrd-card-title{font-size:13px;font-weight:600;color:var(--text)}
.rrd-card-body{padding:14px 16px}
.rrd-charts-row{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.rrd-chart-empty{display:flex;align-items:center;justify-content:center;height:180px;color:var(--muted);font-size:12px;flex-direction:column;gap:6px}
.rrd-tbl-wrap{overflow-x:auto}
table.rrd-tbl{width:100%;border-collapse:collapse;font-size:12px}
table.rrd-tbl thead th{padding:8px 10px;background:#f8f9fa;font-weight:600;font-size:10px;text-align:left;border-bottom:2px solid var(--border);color:var(--muted);text-transform:uppercase;letter-spacing:.3px;white-space:nowrap}
table.rrd-tbl thead th.r{text-align:right}
table.rrd-tbl tbody td{padding:8px 10px;border-bottom:1px solid var(--border);color:var(--text);font-size:11px}
table.rrd-tbl tbody td.r{text-align:right;font-family:'DM Mono',monospace}
table.rrd-tbl tbody td.hi{font-weight:700;color:var(--blue)}
table.rrd-tbl tbody tr:hover{background:#f5f7ff}
table.rrd-tbl tfoot td{padding:8px 10px;font-weight:700;font-size:11px;background:#f0f2f5;border-top:2px solid var(--border)}
table.rrd-tbl tfoot td.r{text-align:right;font-family:'DM Mono',monospace}
.rrd-insights-row{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.rrd-insight-card{background:var(--surface);border:1px solid var(--border);border-radius:12px;overflow:hidden}
.rrd-insight-hdr{padding:11px 16px;border-bottom:1px solid var(--border);background:#fafbfc;font-size:13px;font-weight:600}
.rrd-insight-list{padding:12px 16px;display:grid;gap:8px}
.rrd-insight-item{display:flex;align-items:center;gap:10px;padding:8px 12px;border-radius:8px;background:#f8f9fa}
.rrd-insight-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0}
.rrd-insight-text{font-size:12px;color:var(--text)}
.rrd-insight-val{margin-left:auto;font-family:'DM Mono',monospace;font-size:12px;font-weight:700}
.rrd-smart-item{display:flex;align-items:flex-start;gap:10px;padding:10px 12px;border-radius:8px;border-left:3px solid var(--blue);background:#f0f4ff;margin-bottom:6px}
.rrd-smart-icon{font-size:16px;flex-shrink:0;margin-top:1px}
.rrd-smart-text{font-size:12px;color:var(--text);line-height:1.5}
.rrd-smart-text strong{font-weight:700;color:var(--blue)}
.rrd-overlay{position:fixed;inset:0;background:rgba(0,0,0,.48);display:flex;align-items:center;justify-content:center;z-index:200;padding:14px;backdrop-filter:blur(2px)}
.rrd-modal{background:var(--surface);border-radius:16px;width:100%;max-width:700px;max-height:88vh;overflow:hidden;display:flex;flex-direction:column;animation:rrdUp .22s ease}
@keyframes rrdUp{from{transform:translateY(18px);opacity:0}to{transform:translateY(0);opacity:1}}
.rrd-modal-hdr{background:var(--grad);padding:14px 18px;display:flex;justify-content:space-between;align-items:center;flex-shrink:0}
.rrd-modal-title{color:#fff;font-size:14px;font-weight:600}
.rrd-modal-close{width:26px;height:26px;border-radius:50%;border:none;background:rgba(255,255,255,.2);color:#fff;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.rrd-modal-body{padding:18px;overflow-y:auto}
.rrd-pill{display:inline-flex;align-items:center;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:600}
.rrd-pill.green{background:rgba(5,150,105,.1);color:var(--green)}
.rrd-pill.amber{background:rgba(217,119,6,.1);color:var(--amber)}
.rrd-pill.blue{background:rgba(21,101,192,.1);color:var(--blue)}
.rrd-pill.red{background:rgba(211,47,47,.1);color:var(--red)}
.rrd-export-row{display:flex;gap:8px;flex-wrap:wrap}
.rrd-exp-btn{padding:6px 14px;border-radius:6px;border:none;font-family:inherit;font-size:11px;font-weight:600;cursor:pointer}
.rrd-exp-btn.full{background:var(--grad);color:#fff}
.rrd-exp-btn.cont{background:rgba(21,101,192,.1);color:var(--blue);border:1px solid rgba(21,101,192,.2)}
.rrd-exp-btn.lot{background:rgba(5,150,105,.1);color:var(--green);border:1px solid rgba(5,150,105,.2)}
.rrd-loading{display:flex;align-items:center;justify-content:center;height:300px;gap:10px;color:var(--muted);font-size:13px}
.rrd-spin{width:20px;height:20px;border:2px solid var(--border);border-top-color:var(--blue);border-radius:50%;animation:spin .7s linear infinite}
@keyframes spin{to{transform:rotate(360deg)}}
.rrd-bar-rank{display:flex;align-items:center;gap:8px;padding:6px 0;border-bottom:1px solid var(--border)}
.rrd-bar-rank:last-child{border-bottom:none}
.rrd-bar-label{font-size:11px;width:110px;flex-shrink:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.rrd-bar-track{flex:1;background:#f0f2f5;border-radius:4px;height:12px;overflow:hidden}
.rrd-bar-fill{height:100%;border-radius:4px;transition:width .4s ease}
.rrd-bar-value{font-family:'DM Mono',monospace;font-size:11px;font-weight:600;width:70px;text-align:right;flex-shrink:0}
.rrd-clickable{cursor:pointer;transition:background .15s}
.rrd-clickable:hover{background:#f0f4ff!important}
@media(max-width:900px){.rrd-charts-row,.rrd-insights-row{grid-template-columns:1fr}.rrd-kpi-grid{grid-template-columns:repeat(3,1fr)}}
@media(max-width:600px){.rrd-kpi-grid{grid-template-columns:1fr 1fr}.rrd-main{padding:10px}}
`;

// ─────────────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────────────
const TODAY   = new Date().toISOString().slice(0, 10);
const MONTH_START = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10);
const fmt     = (v, d = 2) => parseFloat(v || 0).toFixed(d);
const fmtN    = (v) => parseFloat(v || 0).toLocaleString('en-IN');
const fmtDate = (d) => { if (!d) return '—'; const dt = new Date(d + 'T00:00:00'); return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }); };
const clr     = ['#1565c0','#d32f2f','#059669','#d97706','#7b1fa2','#0891b2','#dc2626','#16a34a'];

// ─────────────────────────────────────────────────────────────────────────────
// SVG Bar Chart
// ─────────────────────────────────────────────────────────────────────────────
const BarChart = ({ data = [], xKey, bars = [], colors = clr, height = 220, onBarClick }) => {
  if (!data.length) return <div className="rrd-chart-empty"><span>📊</span><span>No data for selected filters</span></div>;
  const W = 520, pL = 48, pB = 52, pT = 18, pR = 12;
  const cW = W - pL - pR, cH = height - pB - pT;
  const maxVal = Math.max(...data.flatMap(d => bars.map(b => parseFloat(d[b.key]) || 0)), 1);
  const gW = cW / data.length;
  const bW = Math.max(6, Math.min(28, (gW / bars.length) - 6));
  const gridLines = [0, 0.25, 0.5, 0.75, 1];
  return (
    <svg viewBox={`0 0 ${W} ${height}`} style={{ width: '100%', height: 'auto', overflow: 'visible' }}>
      {gridLines.map(t => {
        const yy = pT + cH * (1 - t);
        return <g key={t}>
          <line x1={pL} y1={yy} x2={W - pR} y2={yy} stroke="#e2e6ea" strokeWidth="1" />
          <text x={pL - 5} y={yy + 4} textAnchor="end" fontSize="9" fill="#9ca3af">{(maxVal * t).toFixed(0)}</text>
        </g>;
      })}
      {data.map((d, gi) => {
        const midX = pL + gi * gW + gW / 2;
        return (
          <g key={gi} style={onBarClick ? { cursor: 'pointer' } : {}} onClick={() => onBarClick && onBarClick(d)}>
            {bars.map((bar, bi) => {
              const val = parseFloat(d[bar.key]) || 0;
              const bh  = (val / maxVal) * cH;
              const totalGap = bars.length * bW + (bars.length - 1) * 3;
              const x = pL + gi * gW + (gW - totalGap) / 2 + bi * (bW + 3);
              const y = pT + cH - bh;
              return (
                <g key={bi}>
                  <rect x={x} y={y} width={bW} height={Math.max(bh, 2)} fill={colors[bi % colors.length]} rx="3" opacity="0.88">
                    <title>{d[xKey]} — {bar.label}: {val.toFixed(1)}</title>
                  </rect>
                  {bh > 16 && <text x={x + bW / 2} y={y + 11} textAnchor="middle" fontSize="8" fill="#fff" fontWeight="600">{val > 999 ? (val/1000).toFixed(1)+'k' : val.toFixed(0)}</text>}
                </g>
              );
            })}
            <text x={midX} y={height - 6} textAnchor="middle" fontSize="9" fill="#6b7280">
              {String(d[xKey] || '').length > 9 ? String(d[xKey]).slice(0, 9) + '…' : d[xKey]}
            </text>
          </g>
        );
      })}
      <line x1={pL} y1={pT} x2={pL} y2={pT + cH} stroke="#d1d5db" strokeWidth="1" />
      <line x1={pL} y1={pT + cH} x2={W - pR} y2={pT + cH} stroke="#d1d5db" strokeWidth="1" />
    </svg>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SVG Line Chart
// ─────────────────────────────────────────────────────────────────────────────
const LineChart = ({ data = [], xKey, lines = [], colors = clr, height = 200 }) => {
  if (!data.length) return <div className="rrd-chart-empty"><span>📈</span><span>No trend data available</span></div>;
  const W = 520, pL = 48, pB = 42, pT = 18, pR = 12;
  const cW = W - pL - pR, cH = height - pB - pT;
  const allVals = data.flatMap(d => lines.map(l => parseFloat(d[l.key]) || 0));
  const maxV = Math.max(...allVals, 1), minV = 0;
  const X = (i) => pL + (data.length < 2 ? cW / 2 : (i / (data.length - 1)) * cW);
  const Y = (v) => pT + cH - ((v - minV) / (maxV - minV)) * cH;
  const step = Math.max(1, Math.ceil(data.length / 7));
  return (
    <svg viewBox={`0 0 ${W} ${height}`} style={{ width: '100%', height: 'auto' }}>
      {[0, 0.25, 0.5, 0.75, 1].map(t => {
        const yy = pT + cH * (1 - t);
        return <g key={t}>
          <line x1={pL} y1={yy} x2={W - pR} y2={yy} stroke="#e2e6ea" strokeWidth="1" />
          <text x={pL - 5} y={yy + 4} textAnchor="end" fontSize="9" fill="#9ca3af">{(maxV * t).toFixed(1)}</text>
        </g>;
      })}
      {lines.map((line, li) => {
        const pts = data.map((d, i) => `${X(i)},${Y(parseFloat(d[line.key]) || 0)}`).join(' ');
        return (
          <g key={li}>
            <polyline points={pts} fill="none" stroke={colors[li % colors.length]} strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round" />
            {data.map((d, i) => {
              const val = parseFloat(d[line.key]) || 0;
              return (
                <circle key={i} cx={X(i)} cy={Y(val)} r="3.5" fill={colors[li % colors.length]} stroke="#fff" strokeWidth="1.5">
                  <title>{fmtDate(d[xKey])}: {val.toFixed(2)}</title>
                </circle>
              );
            })}
          </g>
        );
      })}
      {data.map((d, i) => {
        if (i % step !== 0 && i !== data.length - 1) return null;
        return (
          <text key={i} x={X(i)} y={height - 5} textAnchor="middle" fontSize="9" fill="#6b7280">
            {String(d[xKey] || '').slice(5)}
          </text>
        );
      })}
      {lines.length > 1 && lines.map((l, li) => (
        <g key={li} transform={`translate(${pL + li * 100}, ${pT - 6})`}>
          <line x1="0" y1="0" x2="16" y2="0" stroke={colors[li % colors.length]} strokeWidth="2" />
          <circle cx="8" cy="0" r="3" fill={colors[li % colors.length]} />
          <text x="20" y="4" fontSize="9" fill="#6b7280">{l.label}</text>
        </g>
      ))}
      <line x1={pL} y1={pT} x2={pL} y2={pT + cH} stroke="#d1d5db" strokeWidth="1" />
      <line x1={pL} y1={pT + cH} x2={W - pR} y2={pT + cH} stroke="#d1d5db" strokeWidth="1" />
    </svg>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// Horizontal rank bars (for contractor / line comparisons)
// ─────────────────────────────────────────────────────────────────────────────
const RankBars = ({ data, labelKey, valueKey, color, unit = '', onItemClick }) => {
  const max = Math.max(...data.map(d => parseFloat(d[valueKey]) || 0), 1);
  return (
    <div style={{ padding: '6px 0' }}>
      {data.map((d, i) => {
        const val = parseFloat(d[valueKey]) || 0;
        const pct = (val / max) * 100;
        return (
          <div key={i} className={`rrd-bar-rank ${onItemClick ? 'rrd-clickable' : ''}`}
            style={{ borderRadius: '6px', padding: '6px 8px', marginBottom: '3px', cursor: onItemClick ? 'pointer' : 'default' }}
            onClick={() => onItemClick && onItemClick(d)}
            title={onItemClick ? `Click to drill down: ${d[labelKey]}` : ''}>
            <span className="rrd-bar-label" style={{ fontSize: '11px', fontWeight: 500 }}>{d[labelKey]}</span>
            <div className="rrd-bar-track">
              <div className="rrd-bar-fill" style={{ width: pct + '%', background: color || clr[i % clr.length] }} />
            </div>
            <span className="rrd-bar-value" style={{ color: color || clr[i % clr.length] }}>{val > 999 ? fmtN(val.toFixed(0)) : val.toFixed(1)}{unit}</span>
          </div>
        );
      })}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// Main Dashboard Component
// ─────────────────────────────────────────────────────────────────────────────
const RomeoReportDashboard = ({ embedded = false }) => {
  const { user } = usePPCAuth();
  const navigate = useNavigate();
  const cssRef   = useRef(false);

  // Inject CSS once
  useEffect(() => {
    if (cssRef.current) return;
    const el = document.createElement('style');
    el.textContent = CSS;
    document.head.appendChild(el);
    cssRef.current = true;
  }, []);

  // ── Filter state ─────────────────────────────────────────────────────────
  const [dateFrom,   setDateFrom]   = useState(MONTH_START);
  const [dateTo,     setDateTo]     = useState(TODAY);
  const [filterLine, setFilterLine] = useState('');
  const [filterCont, setFilterCont] = useState('');
  const [filterShift,setFilterShift]= useState('');
  const [applied,    setApplied]    = useState({ from: MONTH_START, to: TODAY, line: '', cont: '', shift: '' });

  // ── Data state ───────────────────────────────────────────────────────────
  const [loading,   setLoading]   = useState(false);
  const [data,      setData]      = useState(null);
  const [drillDown, setDrillDown] = useState(null);  // { type: 'contractor'|'line', value, rows }
  const [chartTab,  setChartTab]  = useState('honQty'); // trend chart metric

  const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

  // ── Fetch analytics ──────────────────────────────────────────────────────
  const fetchAnalytics = useCallback(async (f) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ action: 'analytics', from: f.from, to: f.to });
      if (f.line)  params.append('line', f.line);
      if (f.cont)  params.append('contractor', f.cont);
      if (f.shift) params.append('shift', f.shift);
      const res = await axios.get(`${PPC_API_URL}/romeo.php?${params}`, auth());
      if (res.data.success) setData(res.data);
      else setData(null);
    } catch (e) {
      console.error(e);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAnalytics(applied); }, [applied, fetchAnalytics]);

  const applyFilters = () => {
    const f = { from: dateFrom, to: dateTo, line: filterLine, cont: filterCont, shift: filterShift };
    setApplied(f);
  };

  // ADDED: Quick-preset state + handler for Daily / Weekly / Monthly buttons
  const [quickPreset, setQuickPreset] = useState('');   // '' | 'daily' | 'weekly' | 'monthly'
  const applyPreset = (preset) => {
    const today = new Date();
    let from, to;
    if (preset === 'daily') {
      from = to = today.toISOString().slice(0, 10);
    } else if (preset === 'weekly') {
      // Monday → Sunday of current week
      const day = today.getDay();
      const mon = new Date(today); mon.setDate(today.getDate() - ((day + 6) % 7));
      const sun = new Date(mon);   sun.setDate(mon.getDate() + 6);
      from = mon.toISOString().slice(0, 10);
      to   = sun.toISOString().slice(0, 10);
    } else if (preset === 'monthly') {
      const y = today.getFullYear(), m = today.getMonth();
      from = new Date(y, m, 1).toISOString().slice(0, 10);
      to   = new Date(y, m + 1, 0).toISOString().slice(0, 10);   // last day of month
    } else {
      return;
    }
    setQuickPreset(preset);
    setDateFrom(from);
    setDateTo(to);
    // Auto-apply immediately — no Apply click needed
    setApplied({ from, to, line: filterLine, cont: filterCont, shift: filterShift });
  };

  const resetFilters = () => {
    setDateFrom(MONTH_START); setDateTo(TODAY);
    setFilterLine(''); setFilterCont(''); setFilterShift('');
    setApplied({ from: MONTH_START, to: TODAY, line: '', cont: '', shift: '' });
    setQuickPreset('');   // ADDED: clear preset highlight on reset
  };

  // ── Derived / computed ───────────────────────────────────────────────────
  const kpi  = data?.kpi  || {};
  const trend = data?.dailyTrend      || [];
  const cpf   = data?.contractorPerf  || [];
  const lines = data?.lineComparison  || [];
  const lots  = data?.lotAnalysis     || [];
  const clist = data?.contractors     || [];

  const bestContractor = cpf.reduce((a, b) => (parseFloat(b.productivity) > parseFloat(a.productivity || 0) ? b : a), {});
  const worstContractor= cpf.reduce((a, b) => (parseFloat(b.productivity) < parseFloat(a.productivity || 999) ? b : a), {});
  const bestLine       = lines.reduce((a, b) => (parseFloat(b.quantity) > parseFloat(a.quantity || 0) ? b : a), {});
  const topLot         = lots[0] || {};

  const smartInsights = [
    { icon: '🏆', color: '#059669', text: <><strong>Top Contractor:</strong> {bestContractor.contractor || '—'} — {fmt(bestContractor.productivity)} trays/hr productivity</> },
    { icon: '🏭', color: '#1565c0', text: <><strong>Best Line:</strong> {bestLine.line || '—'} — {fmt(bestLine.quantity)} KG total quantity</> },
    { icon: '📦', color: '#7b1fa2', text: <><strong>Top Lot:</strong> {topLot.lot_number || '—'} — {fmt(topLot.hon_qty)} KG H.ON Qty</> },
    { icon: '⚠️', color: '#d97706', text: <><strong>Lowest Efficiency:</strong> {worstContractor.contractor || '—'} — {fmt(worstContractor.productivity)} trays/hr</> },
    { icon: '🔢', color: '#1565c0', text: <><strong>Avg KG/Tray:</strong> {fmt(kpi.akt)} KG — Target: 21 KG/tray</> },
    { icon: '⏱️', color: '#059669', text: <><strong>Avg Trays/Hour:</strong> {fmt(kpi.ath)} across {kpi.entries || 0} entries in range</> },
  ];

  // ── Open drill-down modal ────────────────────────────────────────────────
  const openDrillContractor = (d) => {
    setDrillDown({ type: 'contractor', label: d.contractor, data: d,
      rows: lots.filter(() => true) // filtered lot rows would come from backend in full implementation
    });
  };
  const openDrillLine = (d) => {
    const contRows = cpf.filter(c => !applied.line || c.contractor);
    setDrillDown({ type: 'line', label: d.line, data: d, rows: contRows });
  };

  // ── Export handlers ──────────────────────────────────────────────────────
  const exportFull = () => {
    if (!data) return;
    const wb = XLSX.utils.book_new();
    // KPI sheet
    const kpiRows = [
      ['Metric', 'Value'],
      ['Date Range', `${applied.from} to ${applied.to}`],
      ['Total Contractors', kpi.tc || 0],
      ['Total Associates', kpi.ta || 0],
      ['Total Trays', kpi.tt || 0],
      ['Total Vehicles', kpi.tv || 0],
      ['Total Quantity (KG)', fmt(kpi.tq)],
      ['Avg Trays/Hour', fmt(kpi.ath)],
      ['Avg KG/Tray', fmt(kpi.akt)],
    ];
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(kpiRows), 'KPI Summary');
    // Daily Trend
    if (trend.length) {
      const hdrs = ['Date', 'H.ON Qty (KG)', 'H.ON Count', 'Trays/Hour', 'Avg KG/Tray', 'Total Qty (KG)'];
      const rows = trend.map(r => [r.date, fmt(r.hon_qty), r.hon_count || 0, fmt(r.trays_per_hour), fmt(r.avg_kg_tray), fmt(r.total_qty)]);
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([hdrs, ...rows]), 'Daily Trend');
    }
    // Contractor performance
    if (cpf.length) {
      const hdrs = ['Contractor', 'Total H.ON Qty (KG)', 'Total H.ON Count', 'Total Trays', 'Total Qty (KG)', 'Productivity (Trays/Hr)'];
      const rows = cpf.map(r => [r.contractor, fmt(r.total_hon_qty), r.total_hon_count || 0, r.total_trays || 0, fmt(r.total_qty), fmt(r.productivity)]);
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([hdrs, ...rows]), 'Contractor Performance');
    }
    // Line comparison
    if (lines.length) {
      const hdrs = ['Line', 'Quantity (KG)', 'H.ON Qty (KG)', 'Total Trays', 'Productivity (Trays/Hr)'];
      const rows = lines.map(r => [r.line, fmt(r.quantity), fmt(r.hon_qty), r.trays || 0, fmt(r.productivity)]);
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([hdrs, ...rows]), 'Line Comparison');
    }
    XLSX.writeFile(wb, `ROMEO_Report_${applied.from}_to_${applied.to}.xlsx`);
  };

  const exportContractors = () => {
    if (!cpf.length) return;
    const hdrs = ['Contractor', 'Total H.ON Qty (KG)', 'Total H.ON Count', 'Total Trays', 'Total Qty (KG)', 'Productivity'];
    const rows = cpf.map(r => [r.contractor, fmt(r.total_hon_qty), r.total_hon_count || 0, r.total_trays || 0, fmt(r.total_qty), fmt(r.productivity)]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([['ROMEO Contractor Report', `${applied.from} to ${applied.to}`], [], hdrs, ...rows]), 'Contractors');
    XLSX.writeFile(wb, `ROMEO_Contractors_${applied.from}_to_${applied.to}.xlsx`);
  };

  const exportLots = () => {
    if (!lots.length) return;
    const hdrs = ['Lot Number', 'H.ON Count', 'H.ON Qty (KG)', 'Hours', 'Productivity (KG/Hr)'];
    const rows = lots.map(r => [r.lot_number, r.hon_count || 0, fmt(r.hon_qty), r.hours || 0, fmt(r.productivity)]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([['ROMEO Lot-wise Report', `${applied.from} to ${applied.to}`], [], hdrs, ...rows]), 'Lot Analysis');
    XLSX.writeFile(wb, `ROMEO_Lots_${applied.from}_to_${applied.to}.xlsx`);
  };

  // ─────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────
  return (
    <>
      <div className="rrd-wrap">

        {/* ── Header (hidden when embedded inside RomeoDashboard) ── */}
        {!embedded && (
        <header className="rrd-hdr">
          <div className="rrd-hdr-left">
            <button className="rrd-back-btn" onClick={() => navigate(-1)}>← Back</button>
            <div>
              <div className="rrd-title">📊 Romeo Report Dashboard</div>
              <div className="rrd-subtitle">Advanced Analytics · {applied.from} to {applied.to}</div>
            </div>
          </div>
          <div className="rrd-hdr-right">
            {applied.line  && <span className="rrd-badge">Line: {applied.line}</span>}
            {applied.cont  && <span className="rrd-badge">🏭 {applied.cont}</span>}
            {applied.shift && <span className="rrd-badge">{applied.shift === 'DAY' ? '☀️' : '🌙'} {applied.shift}</span>}
            <button className="rrd-export-btn" onClick={exportFull}>📥 Export Full</button>
          </div>
        </header>
        )}

        <main className="rrd-main" style={embedded ? { paddingTop: 18 } : {}}>

          {/* Section heading shown only when embedded */}
          {embedded && (
            <div>
              <div style={{ display:'inline-flex',alignItems:'center',gap:6,padding:'4px 12px',background:'rgba(21,101,192,.08)',borderRadius:20,border:'1px solid rgba(21,101,192,.2)',marginBottom:8 }}>
                <span style={{ fontSize:11,color:'var(--blue)',fontWeight:700,letterSpacing:'.3px' }}>📊 REPORTS</span>
              </div>
              <div style={{ marginBottom:4 }}>
                <span style={{ fontSize:18,fontWeight:700,color:'var(--text)' }}>Romeo Reports</span>
                <span style={{ display:'inline-flex',alignItems:'center',gap:4,marginLeft:10,padding:'2px 9px',borderRadius:20,background:'rgba(5,150,105,.1)',border:'1px solid rgba(5,150,105,.2)',fontSize:10,fontWeight:600,color:'#059669',verticalAlign:'middle' }}>● Live sync</span>
              </div>
              <div style={{ fontSize:12,color:'var(--muted)',marginBottom:14 }}>Summary and analytics — {applied.from} to {applied.to}</div>
            </div>
          )}

          {/* ── Filter Bar ── */}
          <div className="rrd-filter-bar">
            {/* ADDED: Daily / Weekly / Monthly quick-preset buttons */}
            <div className="rrd-ff" style={{ minWidth: 'auto' }}>
              <label>Quick</label>
              <div style={{ display:'inline-flex', gap:4, padding:3, background:'#f8f9fa', border:'1px solid #e2e6ea', borderRadius:7 }}>
                {[
                  { val:'daily',   label:'Daily',   icon:'📅' },
                  { val:'weekly',  label:'Weekly',  icon:'📆' },
                  { val:'monthly', label:'Monthly', icon:'🗓️' },
                ].map(p => {
                  const active = quickPreset === p.val;
                  return (
                    <button key={p.val} type="button" onClick={() => applyPreset(p.val)}
                      style={{
                        padding:'5px 11px', borderRadius:5,
                        border:'none',
                        background: active ? 'linear-gradient(135deg,#7c3aed,#1565c0)' : 'transparent',
                        color: active ? '#fff' : '#6b7280',
                        fontSize:11, fontWeight:700, cursor:'pointer', fontFamily:'inherit',
                      }}>
                      {p.icon} {p.label}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className="rrd-ff">
              <label>Date From</label>
              <input type="date" value={dateFrom} onChange={e => { setDateFrom(e.target.value); setQuickPreset(''); }} />
            </div>
            <div className="rrd-ff">
              <label>Date To</label>
              <input type="date" value={dateTo} onChange={e => { setDateTo(e.target.value); setQuickPreset(''); }} />
            </div>
            <div className="rrd-ff">
              <label>Line</label>
              <select value={filterLine} onChange={e => setFilterLine(e.target.value)}>
                <option value="">All Lines</option>
                <option value="ROMEO 1">ROMEO 1</option>
                <option value="ROMEO 2">ROMEO 2</option>
              </select>
            </div>
            <div className="rrd-ff">
              <label>Contractor</label>
              <select value={filterCont} onChange={e => setFilterCont(e.target.value)}>
                <option value="">All Contractors</option>
                {clist.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div className="rrd-ff">
              <label>Shift</label>
              <select value={filterShift} onChange={e => setFilterShift(e.target.value)}>
                <option value="">All Shifts</option>
                <option value="DAY">☀️ Day</option>
                <option value="NIGHT">🌙 Night</option>
              </select>
            </div>
            <button className="rrd-apply-btn" onClick={applyFilters}>▶ Apply</button>
            <button className="rrd-reset-btn" onClick={resetFilters}>↺ Reset</button>
          </div>

          {/* ── Export row ── */}
          <div className="rrd-export-row">
            <button className="rrd-exp-btn full" onClick={exportFull}>📥 Full Report Export</button>
            <button className="rrd-exp-btn cont" onClick={exportContractors}>📋 Contractor Export</button>
            <button className="rrd-exp-btn lot"  onClick={exportLots}>🗂️ Lot-wise Export</button>
          </div>

          {loading ? (
            <div className="rrd-loading"><div className="rrd-spin" /><span>Loading analytics data…</span></div>
          ) : !data ? (
            <div className="rrd-loading" style={{ flexDirection: 'column', gap: 12 }}>
              <span style={{ fontSize: 32 }}>⚠️</span>
              <span style={{ fontWeight: 600, color: 'var(--red)' }}>Backend endpoint not connected</span>
              <span style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'center', maxWidth: 400 }}>
                Add the <code>analytics</code> action to <code>romeo.php</code> as documented at the top of this file, then apply filters.
              </span>
            </div>
          ) : (
            <>

              {/* ── KPI Cards ── */}
              <div className="rrd-kpi-grid">
                {[
                  { icon: '🏭', label: 'Total Contractors', val: kpi.tc || 0, cls: '', vcls: 'blue' },
                  { icon: '👷', label: 'Total Associates',  val: fmtN(kpi.ta || 0), cls: 'green', vcls: 'green' },
                  { icon: '🗂️', label: 'Total Trays',       val: fmtN(kpi.tt || 0), cls: 'purple', vcls: 'purple' },
                  { icon: '🚛', label: 'Total Vehicles',    val: kpi.tv || 0, cls: '', vcls: 'blue' },
                  { icon: '⚖️', label: 'Total H.ON Qty (KG)', val: fmtN(parseFloat(kpi.total_hon_qty || 0).toFixed(0)), cls: 'amber', vcls: 'amber' },
                  { icon: '🔢', label: 'Total H.ON Count',  val: fmtN(kpi.total_hon_count || 0), cls: 'amber', vcls: 'amber' },
                  { icon: '📦', label: 'Total Quantity (KG)',val: fmtN(parseFloat(kpi.tq || 0).toFixed(0)), cls: 'green', vcls: 'green' },
                  { icon: '📈', label: 'Avg Trays / Hour',  val: fmt(kpi.ath), cls: '', vcls: 'blue' },
                  { icon: '⚡', label: 'Avg KG / Tray',     val: fmt(kpi.akt), cls: 'red', vcls: 'red' },
                ].map((k, i) => (
                  <div key={i} className={`rrd-kpi ${k.cls}`}>
                    <span className="rrd-kpi-icon">{k.icon}</span>
                    <div>
                      <div className="rrd-kpi-label">{k.label}</div>
                      <div className={`rrd-kpi-val ${k.vcls}`}>{k.val}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* ── Trend Charts Row ── */}
              <div className="rrd-charts-row">

                {/* Production Trend */}
                <div className="rrd-card">
                  <div className="rrd-card-hdr">
                    <span className="rrd-card-title">📈 Production Trend</span>
                    <div style={{ display: 'flex', gap: 5 }}>
                      {[{ k: 'hon_qty', l: 'H.ON Qty' }, { k: 'total_qty', l: 'Total Qty' }].map(t => (
                        <button key={t.k} onClick={() => setChartTab(t.k)}
                          style={{ padding: '4px 10px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600, fontFamily: 'inherit',
                            background: chartTab === t.k ? 'var(--grad)' : '#f0f2f5', color: chartTab === t.k ? '#fff' : 'var(--muted)' }}>
                          {t.l}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="rrd-card-body">
                    <LineChart data={trend} xKey="date"
                      lines={[{ key: chartTab, label: chartTab === 'hon_qty' ? 'H.ON Qty' : 'Total Qty' }]}
                      colors={['#1565c0']} height={200} />
                  </div>
                </div>

                {/* Trays Efficiency Trend */}
                <div className="rrd-card">
                  <div className="rrd-card-hdr">
                    <span className="rrd-card-title">⚙️ Trays Efficiency Trend</span>
                    <span className="rrd-pill blue">Trays/Hr &amp; KG/Tray</span>
                  </div>
                  <div className="rrd-card-body">
                    <LineChart data={trend} xKey="date"
                      lines={[{ key: 'trays_per_hour', label: 'Trays/Hr' }, { key: 'avg_kg_tray', label: 'KG/Tray' }]}
                      colors={['#7b1fa2', '#d97706']} height={200} />
                  </div>
                </div>
              </div>

              {/* ── Contractor + Line Charts Row ── */}
              <div className="rrd-charts-row">

                {/* Contractor Performance */}
                <div className="rrd-card">
                  <div className="rrd-card-hdr">
                    <span className="rrd-card-title">🏭 Contractor Performance</span>
                    <span className="rrd-pill amber">Click to drill down</span>
                  </div>
                  <div className="rrd-card-body">
                    {cpf.length > 0 ? (
                      <>
                        <div style={{ marginBottom: 10 }}>
                          <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--muted)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.3px' }}>H.ON Qty (KG)</div>
                          <RankBars data={cpf} labelKey="contractor" valueKey="total_hon_qty" color="#1565c0" onItemClick={openDrillContractor} />
                        </div>
                        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 10, marginTop: 4 }}>
                          <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--muted)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.3px' }}>Total Trays</div>
                          <RankBars data={cpf} labelKey="contractor" valueKey="total_trays" color="#7b1fa2" />
                        </div>
                      </>
                    ) : <div className="rrd-chart-empty"><span>🏭</span><span>No contractor data</span></div>}
                  </div>
                </div>

                {/* Line Comparison */}
                <div className="rrd-card">
                  <div className="rrd-card-hdr">
                    <span className="rrd-card-title">🔀 ROMEO 1 vs ROMEO 2</span>
                    <span className="rrd-pill blue">Click to drill down</span>
                  </div>
                  <div className="rrd-card-body">
                    {lines.length > 0 ? (
                      <>
                        <BarChart
                          data={lines} xKey="line"
                          bars={[{ key: 'quantity', label: 'Total Qty (KG)' }, { key: 'trays', label: 'Total Trays' }]}
                          colors={['#1565c0', '#7b1fa2']}
                          height={180}
                          onBarClick={openDrillLine}
                        />
                        <div style={{ display: 'flex', gap: 14, marginTop: 10, padding: '10px 0', borderTop: '1px solid var(--border)', justifyContent: 'center' }}>
                          {lines.map((l, i) => (
                            <div key={i} style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => openDrillLine(l)}>
                              <div style={{ fontSize: 10, color: 'var(--muted)', fontWeight: 600, marginBottom: 3 }}>{l.line}</div>
                              <div style={{ fontFamily: 'monospace', fontSize: 13, fontWeight: 700, color: i === 0 ? '#1565c0' : '#7b1fa2' }}>{fmt(l.productivity)} <span style={{ fontSize: 10, fontWeight: 400 }}>trays/hr</span></div>
                            </div>
                          ))}
                        </div>
                      </>
                    ) : <div className="rrd-chart-empty"><span>🔀</span><span>No line comparison data</span></div>}
                  </div>
                </div>
              </div>

              {/* ── Lot-wise Analysis Table ── */}
              <div className="rrd-card">
                <div className="rrd-card-hdr">
                  <span className="rrd-card-title">🗂️ Lot-wise Analysis</span>
                  {/* ADDED: inline Daily/Weekly/Monthly quick-filter buttons next to the title */}
                  <div style={{ display:'inline-flex', gap:4, padding:3, background:'#f8f9fa', border:'1px solid #e2e6ea', borderRadius:7, marginLeft:10 }}>
                    {[
                      { val:'daily',   label:'Daily',   icon:'📅' },
                      { val:'weekly',  label:'Weekly',  icon:'📆' },
                      { val:'monthly', label:'Monthly', icon:'🗓️' },
                    ].map(p => {
                      const active = quickPreset === p.val;
                      return (
                        <button key={p.val} type="button" onClick={() => applyPreset(p.val)}
                          style={{
                            padding:'5px 11px', borderRadius:5,
                            border:'none',
                            background: active ? 'linear-gradient(135deg,#7c3aed,#1565c0)' : 'transparent',
                            color: active ? '#fff' : '#6b7280',
                            fontSize:11, fontWeight:700, cursor:'pointer', fontFamily:'inherit',
                          }}>
                          {p.icon} {p.label}
                        </button>
                      );
                    })}
                  </div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginLeft:'auto' }}>
                    <span className="rrd-pill blue">{lots.length} lots</span>
                    <button className="rrd-exp-btn lot" onClick={exportLots} style={{ padding: '4px 10px', fontSize: 11 }}>📥 Export</button>
                  </div>
                </div>
                <div className="rrd-tbl-wrap">
                  {lots.length > 0 ? (
                    <table className="rrd-tbl">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Lot Number</th>
                          <th className="r">H.ON Count</th>
                          <th className="r">H.ON Qty (KG)</th>
                          <th className="r">Hours</th>
                          <th className="r">Productivity (KG/Hr)</th>
                          <th className="r">% of Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lots.map((r, i) => {
                          const totalHonQty = lots.reduce((s, l) => s + (parseFloat(l.hon_qty) || 0), 0);
                          const pct = totalHonQty > 0 ? ((parseFloat(r.hon_qty) || 0) / totalHonQty * 100).toFixed(1) : '0.0';
                          const prod = parseFloat(r.productivity) || 0;
                          const prodCls = prod >= 150 ? 'green' : prod >= 100 ? '' : 'red';
                          return (
                            <tr key={i}>
                              <td style={{ color: 'var(--muted)', fontSize: 10 }}>{i + 1}</td>
                              <td className="hi" style={{ fontFamily: 'monospace', fontSize: 11 }}>{r.lot_number || '—'}</td>
                              <td className="r">{fmtN(r.hon_count || 0)}</td>
                              <td className="r" style={{ fontWeight: 700, color: 'var(--blue)' }}>{fmt(r.hon_qty)}</td>
                              <td className="r">{fmt(r.hours, 1)}</td>
                              <td className="r">
                                <span className={`rrd-pill ${prodCls}`} style={{ justifyContent: 'flex-end' }}>
                                  {fmt(r.productivity)} KG/hr
                                </span>
                              </td>
                              <td className="r">
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 }}>
                                  <div style={{ width: 50, height: 6, background: '#e2e6ea', borderRadius: 3, overflow: 'hidden' }}>
                                    <div style={{ width: pct + '%', height: '100%', background: 'var(--blue)', borderRadius: 3 }} />
                                  </div>
                                  <span style={{ fontSize: 10, fontFamily: 'monospace', color: 'var(--muted)' }}>{pct}%</span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={2}>TOTAL ({lots.length} lots)</td>
                          <td className="r">{fmtN(lots.reduce((s, r) => s + (parseInt(r.hon_count) || 0), 0))}</td>
                          <td className="r" style={{ color: 'var(--blue)' }}>{fmtN(lots.reduce((s, r) => s + (parseFloat(r.hon_qty) || 0), 0).toFixed(2))}</td>
                          <td className="r">{fmt(lots.reduce((s, r) => s + (parseFloat(r.hours) || 0), 0), 1)}</td>
                          <td className="r">—</td>
                          <td className="r">100%</td>
                        </tr>
                      </tfoot>
                    </table>
                  ) : (
                    <div className="rrd-chart-empty" style={{ height: 120 }}>
                      <span>🗂️</span><span>No data available for selected timeframe.</span>
                    </div>
                  )}
                </div>
              </div>

              {/* ── Productivity Insights + Smart Insights ── */}
              <div className="rrd-insights-row">

                {/* Productivity Insights */}
                <div className="rrd-insight-card">
                  <div className="rrd-insight-hdr">⚡ Productivity Insights</div>
                  <div className="rrd-insight-list">
                    {[
                      { icon: '🏆', color: '#059669', label: 'Best Contractor', val: bestContractor.contractor || '—', sub: `${fmt(bestContractor.productivity)} trays/hr` },
                      { icon: '📉', color: '#d97706', label: 'Lowest Efficiency', val: worstContractor.contractor || '—', sub: `${fmt(worstContractor.productivity)} trays/hr` },
                      { icon: '🏭', color: '#1565c0', label: 'Best Line',         val: bestLine.line || '—',             sub: `${fmt(bestLine.quantity)} KG total` },
                      { icon: '📦', color: '#7b1fa2', label: 'Top Lot',           val: topLot.lot_number || '—',         sub: `${fmt(topLot.hon_qty)} KG H.ON Qty` },
                      { icon: '📊', color: '#059669', label: 'Total Entries',     val: kpi.entries || 0,                  sub: `from ${applied.from} to ${applied.to}` },
                      { icon: '⚙️', color: '#1565c0', label: 'Overall Avg KG/Tray',val: `${fmt(kpi.akt)} KG`,            sub: 'Target: 21 KG per tray' },
                    ].map((item, i) => (
                      <div key={i} className="rrd-insight-item">
                        <span style={{ fontSize: 16 }}>{item.icon}</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 10, color: 'var(--muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.3px' }}>{item.label}</div>
                          <div style={{ fontSize: 12, fontWeight: 700, color: item.color, fontFamily: 'monospace' }}>{item.val}</div>
                          <div style={{ fontSize: 10, color: 'var(--muted)' }}>{item.sub}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Smart Insights */}
                <div className="rrd-insight-card">
                  <div className="rrd-insight-hdr">💡 Smart Insights</div>
                  <div style={{ padding: '12px 16px' }}>
                    {smartInsights.map((ins, i) => (
                      <div key={i} className="rrd-smart-item" style={{ borderLeftColor: ins.color }}>
                        <span className="rrd-smart-icon">{ins.icon}</span>
                        <span className="rrd-smart-text">{ins.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </>
          )}
        </main>
      </div>

      {/* ── Drill-down Modal ── */}
      {drillDown && (
        <div className="rrd-overlay" onClick={() => setDrillDown(null)}>
          <div className="rrd-modal" onClick={e => e.stopPropagation()}>
            <div className="rrd-modal-hdr">
              <span className="rrd-modal-title">
                {drillDown.type === 'contractor' ? '🏭' : '🔀'} {drillDown.label} — Detailed Breakdown
              </span>
              <button className="rrd-modal-close" onClick={() => setDrillDown(null)}>×</button>
            </div>
            <div className="rrd-modal-body">
              {drillDown.type === 'contractor' && drillDown.data && (
                <>
                  <div className="rrd-kpi-grid" style={{ marginBottom: 16 }}>
                    {[
                      { icon: '📦', label: 'Total Qty (KG)',    val: fmt(drillDown.data.total_qty),     cls: 'green', vcls: 'green' },
                      { icon: '⚖️', label: 'H.ON Qty (KG)',     val: fmt(drillDown.data.total_hon_qty), cls: 'amber', vcls: 'amber' },
                      { icon: '🗂️', label: 'Total Trays',       val: drillDown.data.total_trays || 0,   cls: 'purple', vcls: 'purple' },
                      { icon: '📈', label: 'Productivity',      val: `${fmt(drillDown.data.productivity)} t/hr`, cls: '', vcls: 'blue' },
                    ].map((k, i) => (
                      <div key={i} className={`rrd-kpi ${k.cls}`}>
                        <span className="rrd-kpi-icon">{k.icon}</span>
                        <div>
                          <div className="rrd-kpi-label">{k.label}</div>
                          <div className={`rrd-kpi-val ${k.vcls}`}>{k.val}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{ padding: '12px', background: '#f0f4ff', borderRadius: 8, fontSize: 12, color: 'var(--muted)', textAlign: 'center' }}>
                    💡 For full lot-wise breakdown per contractor, the <code>analytics</code> endpoint can be extended to accept a <code>contractor</code> parameter and return filtered lot data.
                  </div>
                </>
              )}
              {drillDown.type === 'line' && (
                <>
                  <div className="rrd-kpi-grid" style={{ marginBottom: 16 }}>
                    {[
                      { icon: '📦', label: 'Total Qty (KG)',  val: fmt(drillDown.data.quantity),    cls: 'green', vcls: 'green' },
                      { icon: '⚖️', label: 'H.ON Qty (KG)',   val: fmt(drillDown.data.hon_qty),     cls: 'amber', vcls: 'amber' },
                      { icon: '🗂️', label: 'Total Trays',     val: drillDown.data.trays || 0,       cls: 'purple', vcls: 'purple' },
                      { icon: '📈', label: 'Productivity',    val: `${fmt(drillDown.data.productivity)} t/hr`, cls: '', vcls: 'blue' },
                    ].map((k, i) => (
                      <div key={i} className={`rrd-kpi ${k.cls}`}>
                        <span className="rrd-kpi-icon">{k.icon}</span>
                        <div>
                          <div className="rrd-kpi-label">{k.label}</div>
                          <div className={`rrd-kpi-val ${k.vcls}`}>{k.val}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 12 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--muted)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '.3px' }}>Contractors on {drillDown.label}</div>
                    {cpf.length > 0 ? (
                      <table className="rrd-tbl">
                        <thead>
                          <tr>
                            <th>Contractor</th>
                            <th className="r">H.ON Qty (KG)</th>
                            <th className="r">Total Trays</th>
                            <th className="r">Productivity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cpf.map((c, i) => (
                            <tr key={i}>
                              <td className="hi">{c.contractor}</td>
                              <td className="r">{fmt(c.total_hon_qty)}</td>
                              <td className="r">{c.total_trays || 0}</td>
                              <td className="r">
                                <span className="rrd-pill blue">{fmt(c.productivity)} t/hr</span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : <div style={{ color: 'var(--muted)', fontSize: 12, textAlign: 'center', padding: 20 }}>No contractor data for {drillDown.label}</div>}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RomeoReportDashboard;
